import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { ThoughtworksDemoService } from '@app/services/thoughtworks-demos.service';
import { TitleService } from '@app/services/title.service';
import { environment } from '@environments/environment';
import { Title } from 'chart.js/dist';

type ThoughtworksDemoItem = {
  id: number;
  title: string;
  description: string;
  duration: string;
  recordedDate: string;
  videoUrl: string;
};

@Component({
  selector: 'app-thoughtworks-demos',
  templateUrl: './thoughtworks-demos.component.html',
  styleUrls: ['./thoughtworks-demos.component.scss']
})
export class ThoughtworksDemosComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  pageData = '';
  courseLink = '';
  items: ThoughtworksDemoItem[];
  constructor(private route: ActivatedRoute,
    private titleService: TitleService,
    private thoughtworksDemoService: ThoughtworksDemoService,) { }

  ngOnInit(): void {
    this.route.data
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        switch (data.kind) {
          case 'data-products':
            {
              this.pageData = 'data-products';
              this.pageTitleArea = [
                {
                  title: 'University',
                  subTitle: 'Thoughtworks Demos'
                }
              ];
              this.courseLink = "https://kepler-docs.apps.dp01.exxonmobil.com/deeper_dive/";
              this.thoughtworksDemoService.getDemos()
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(demos => {
                  this.items = demos;
                  this.items[0].videoUrl = environment.referenceDataMeshPlatformInteractiveDemo;
                  this.items[1].videoUrl = environment.howToScoutAndScopeADataProduct;
                  this.items[2].videoUrl = environment.deepDiveForDataProductsOnUDF;
                  this.items[3].videoUrl = environment.understandingModernDataEngineeringAndArchitecture;
                  this.items[4].videoUrl = environment.dataProductDeploymentTrackerDemo;
                });
              break;
            }
        }
      });

    this.titleService.setTitle('University');
  }

  pageTitleArea: pageTitle[] = [
    {
      title: 'University',
      subTitle: 'Getting Started'
    }
  ]

}
class pageTitle {
  title: string;
  subTitle: string;
}
